<div class="orders-list-skeleton">
    <!-- Header -->
    <div class="row align-items-center mb-4 g-3">
        <div class="col-12 col-md-auto text-center text-md-start">
            <app-skeleton-rect width="150px" height="28px" class="mb-2 d-inline-block"></app-skeleton-rect>
            <app-skeleton-rect width="120px" height="16px" class="d-block mx-auto mx-md-0"></app-skeleton-rect>
        </div>
        <div
            class="col-12 col-md-auto ms-md-auto d-flex justify-content-center justify-content-md-end align-items-center gap-2">
            <app-skeleton-rect width="140px" height="32px" [borderRadius]="'6px'"></app-skeleton-rect>
            <app-skeleton-rect width="80px" height="32px" [borderRadius]="'6px'"></app-skeleton-rect>
            <app-skeleton-rect width="90px" height="32px" [borderRadius]="'6px'"></app-skeleton-rect>
        </div>
    </div>

    <!-- KPI Cards -->
    <div class="row">
        <div class="col-xl-3 col-lg-6 col-12" *ngFor="let i of [0,1,2,3]">
            <div class="card">
                <div class="card-body">
                    <div class="d-flex justify-content-between align-items-center">
                        <div>
                            <app-skeleton-rect width="100px" height="14px" class="mb-2 d-block"></app-skeleton-rect>
                            <div class="d-flex align-items-center">
                                <app-skeleton-rect width="50px" height="28px" class="me-2"></app-skeleton-rect>
                                <app-skeleton-rect width="40px" height="20px"
                                    [borderRadius]="'10px'"></app-skeleton-rect>
                            </div>
                        </div>
                        <app-skeleton-rect width="50px" height="50px" [borderRadius]="'50%'"></app-skeleton-rect>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Orders Table Card -->
    <div class="card">
        <div class="card-header">
            <div class="d-flex justify-content-between align-items-center">
                <app-skeleton-rect width="150px" height="22px"></app-skeleton-rect>
                <div class="d-flex gap-2">
                    <app-skeleton-rect width="200px" height="32px"></app-skeleton-rect>
                    <app-skeleton-rect width="150px" height="32px"></app-skeleton-rect>
                </div>
            </div>
        </div>
        <div class="card-body">
            <!-- Table Header -->
            <div class="table-header d-flex align-items-center py-2 px-2 mb-2">
                <app-skeleton-rect width="150px" height="18px" class="me-auto"></app-skeleton-rect>
                <app-skeleton-rect width="100px" height="18px" class="me-4"></app-skeleton-rect>
                <app-skeleton-rect width="80px" height="18px" class="me-4"></app-skeleton-rect>
                <app-skeleton-rect width="100px" height="18px" class="me-4"></app-skeleton-rect>
                <app-skeleton-rect width="80px" height="18px"></app-skeleton-rect>
            </div>

            <!-- Table Rows -->
            <ng-container *ngFor="let i of [0,1,2,3,4]">
                <div class="table-row d-flex align-items-center py-3 px-2">
                    <!-- Product -->
                    <div class="d-flex align-items-center me-auto" style="min-width: 200px;">
                        <app-skeleton-rect width="50px" height="50px" [borderRadius]="'8px'"
                            class="me-3"></app-skeleton-rect>
                        <div>
                            <app-skeleton-rect width="140px" height="16px" class="mb-1 d-block"></app-skeleton-rect>
                            <app-skeleton-rect width="80px" height="12px" class="d-block"></app-skeleton-rect>
                        </div>
                    </div>
                    <!-- Tracking ID -->
                    <app-skeleton-rect width="90px" height="16px" class="me-4"></app-skeleton-rect>
                    <!-- Price -->
                    <app-skeleton-rect width="70px" height="16px" class="me-4"></app-skeleton-rect>
                    <!-- Date -->
                    <app-skeleton-rect width="90px" height="16px" class="me-4"></app-skeleton-rect>
                    <!-- Status -->
                    <app-skeleton-rect width="80px" height="28px" [borderRadius]="'6px'"></app-skeleton-rect>
                </div>
            </ng-container>

            <!-- Pagination -->
            <div class="d-flex justify-content-between align-items-center mt-3 pt-3 border-top">
                <app-skeleton-rect width="100px" height="18px"></app-skeleton-rect>
                <div class="d-flex gap-2">
                    <app-skeleton-rect width="32px" height="32px" [borderRadius]="'6px'"></app-skeleton-rect>
                    <app-skeleton-rect width="32px" height="32px" [borderRadius]="'6px'"></app-skeleton-rect>
                    <app-skeleton-rect width="32px" height="32px" [borderRadius]="'6px'"></app-skeleton-rect>
                </div>
            </div>
        </div>
    </div>
</div>